const arrowUp = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><polyline stroke-width="1.5" points="4 10 8.04 6 12 9.92"/></svg>',
};

export { arrowUp as default };
